import axios from "axios";

function resolveApiBaseUrl() {
  const configuredUrl = process.env.REACT_APP_BACKEND_URL?.trim();
  const fallbackUrl =
    typeof window !== "undefined" ? window.location.origin : "";

  const rootUrl = (configuredUrl || fallbackUrl).replace(/\/+$/, "");

  // Hostinger currently allows REACT_APP_BACKEND_URL to be either:
  // https://example.com or https://example.com/api
  return rootUrl.endsWith("/api") ? rootUrl : `${rootUrl}/api`;
}

export const API_BASE_URL = resolveApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 30000,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/auth/")
    ) {
      originalRequest._retry = true;

      try {
        await axios.post(
          `${API_BASE_URL}/auth/refresh`,
          {},
          { withCredentials: true }
        );

        return api(originalRequest);
      } catch {
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) {
    return "Something went wrong. Please try again.";
  }

  if (typeof detail === "string") {
    return detail;
  }

  if (Array.isArray(detail)) {
    return detail
      .map((entry) =>
        entry && typeof entry.msg === "string"
          ? entry.msg
          : JSON.stringify(entry)
      )
      .filter(Boolean)
      .join(" ");
  }

  if (detail && typeof detail.msg === "string") {
    return detail.msg;
  }

  return String(detail);
}
